import rlite from "rlite-router";

import {
	airblocks,
	airspaceAvailability,
	airspaces,
	airTrafficControllerMessage,
	airways,
	clearedFlightLevelMessage,
	currentAirspaceConfiguration,
	exitFlightLevelMessage,
	flightConflictMessage,
	flightEnteringAirspaceMessage,
	flightRoutes,
	frequencies,
	frontendACCBearing,
	frontendACCFlightLevel,
	frontendAssignedFlightLevel,
	frontendFlightController,
	frontendFlightHidden,
	frontendForceRefresh,
	frontendLocalAssignedFlightLevel,
	frontendManualAP,
	frontendNextSectorFlightLevel,
	frontendPredictiveTrajectoryState,
	frontendSpeed,
	frontendWarningLevel,
	ignored,
	initCompleted,
	isaUpdate,
	newAircraftMessage,
	newAircraftTypeMessage,
	newAirspaceConfiguration,
	newAvailabilitySchedule,
	newFlight,
	newFlightMilestonePositions,
	newPointMessage,
	newSector,
	newSimulatorTime,
	notFound,
	pilotRequest,
	pilotRequestJson,
	roleConfiguration,
	simulatorLogs,
	simulatorPresenceStatus,
	simulatorStartupConfiguration,
	targetReport,
	workloadUpdate,
} from "./subscribers";

const router = rlite<Buffer>(notFound, {
	"ats/:clientId/data/init-completed": initCompleted,
	"ats/:clientId/data/target-reports/:vehicleId": targetReport,
	"ats/:clientId/data/availability-schedule": newAvailabilitySchedule,
	"ats/:clientId/data/flight-milestone-times/:flightUniqueId/:planningStage/:milestone":
		ignored,
	"ats/:clientId/data/flight-milestone-positions/:flightUniqueId/:planningStage/:milestone":
		newFlightMilestonePositions,
	"ats/:clientId/data/planned-flights/:flightUniqueId": ignored,
	"ats/:clientId/data/aircraft-types/:vehicleTypeId": newAircraftTypeMessage,
	"ats/:clientId/data/aircrafts/:vehicleTypeId": newAircraftMessage,
	"ats/:clientId/data/flights/:flightUniqueId": newFlight,
	"ats/:clientId/data/flight-status/:flightUniqueId": ignored,
	"ats/:clientId/data/routes/:networkId/:objectId": ignored,
	"ats/:clientId/data/flight-routes/:flightUniqueId": flightRoutes,
	"ats/:clientId/data/airspaces/:airspaceId": airspaces,
	"ats/:clientId/data/sectors/:sectorId": newSector,
	"ats/:clientId/data/airblocks/:airblockId": airblocks,
	"ats/:clientId/data/airspace-configs/:configurationId":
		newAirspaceConfiguration,
	"ats/:clientId/data/airspace-availability/:airspaceId/:time":
		airspaceAvailability,
	"ats/:clientId/data/segments/:segmentId": ignored,
	"ats/:clientId/data/waypoints/:objectId": ignored,
	"ats/:clientId/data/points/:nodeId": newPointMessage,
	"ats/:clientId/data/airways": airways,
	"ats/:clientId/data/frequencies": frequencies,
	"ats/:clientId/data/role-configs/:roleName": roleConfiguration,
	"ats/:clientId/data/current-config": currentAirspaceConfiguration,
	"ats/:clientId/data/controller-assignments/:objectId/:time":
		airTrafficControllerMessage,
	"ats/:clientId/data/flight-entering-airspace/:flightUniqueId/:time":
		flightEnteringAirspaceMessage,
	"ats/:clientId/data/xfl/:flightUniqueId": exitFlightLevelMessage,
	"ats/:clientId/data/cfl/:flightUniqueId": clearedFlightLevelMessage,
	"ats/:clientId/data/pilot-request/:flightUniqueId/:requestId": pilotRequest,
	"ats/:clientId/data/tessellated-volumes/:airspaceVolumeId": ignored,
	"ats/:clientId/data/volume-flight-lists/:airspaceVolumeId": ignored,
	"ats/:clientId/data/accepted-flights/:toControllableAirspaceVolume/:flightId":
		ignored,
	"ats/:clientId/data/tentative-flights/:toControllableAirspaceVolume/:flightId":
		ignored,
	"ats/:clientId/status/time": newSimulatorTime,
	"ats/:clientId/status/config/startup": simulatorStartupConfiguration,
	"ats/:clientId/status/:status": ignored,
	"ats/:clientId/logs": simulatorLogs,
	"ats/:clientId/data/flight-conflicts/:conflictType/:flightUniqueId1/:flightUniqueId2":
		flightConflictMessage,
	"frontend/:clientId/flight/:flightId/controller": frontendFlightController,
	"frontend/:clientId/flight/:flightId/ACCFL": frontendACCFlightLevel,
	"frontend/:clientId/flight/:flightId/NSFL": frontendNextSectorFlightLevel,
	"frontend/:clientId/flight/:flightId/ACCBearing": frontendACCBearing,
	"frontend/:clientId/flight/:flightId/assignedFL": frontendAssignedFlightLevel,
	"frontend/:clientId/flight/:flightId/speed": frontendSpeed,
	"frontend/:clientId/flight/:flightId/predictiveTrajectoryState":
		frontendPredictiveTrajectoryState,
	"frontend/:clientId/flight/:flightId/localAssignedFL":
		frontendLocalAssignedFlightLevel,
	"frontend/:clientId/flight/:flightId/hidden": frontendFlightHidden,
	"frontend/:clientId/cwp/:roleName/flight/:flightId/warningLevel":
		frontendWarningLevel,
	"frontend/:clientId/commands/force-refresh": frontendForceRefresh,
	"ats/:clientId/status/presence/:sessionUuid": simulatorPresenceStatus,
	"frontend/:clientId/brain/manualAP": frontendManualAP,
	"IIS/:clientId/PilotRequest": pilotRequestJson,
	"IIS/:clientId/PilotRequest/:requestId": pilotRequestJson,
	"TAS/:clientId/WorkloadUpdate": workloadUpdate,
	"TAS/:clientId/ISAUpdate": isaUpdate,
});

export default router;
